module.exports = __webpack_public_path__ + "images/2-sim-rear.f4034a011dd0f4f5a015ab1de87c36eb.png";